import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { sportOfferListArray } from 'config/Filter/sectionCollection';

import { useAttributeListAtom } from 'hooks/form/filter';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { QaIdentifier } from 'hooks/useQa';

import { AttributesSearchParam } from 'types/Search/params';

import ScopedAttribute from '../ScopedAttribute';
import { MetaValue } from '../Segment/__hooks/useDisabledStatus';

import {
    availableAttributListMap,
    availableSpotActivityList,
} from './__helper/possibleSpotActivityList';

const Sport = ({ disableWhen = MetaValue.NoResult }) => {
    const { t } = useTranslation();
    const [attributeList] = useAttributeListAtom();
    const { setItemPhpSessionScope } = useLocalStorage();

    useEffect(() => {
        const sportListArray = Array.from(attributeList).filter(
            (attribute) => availableSpotActivityList.indexOf(attribute) > -1
        );
        const sportList = sportListArray.map((attribute) =>
            t(availableAttributListMap[attribute] ?? 'TRANS').toLowerCase()
        );

        setItemPhpSessionScope('indiSpotActivity', sportList.join(','));
    }, [attributeList, setItemPhpSessionScope, t]);

    return (
        <ScopedAttribute
            attributeListArray={sportOfferListArray}
            headlineKey="TRANS-sport-offers"
            disableWhen={disableWhen}
            qaIdentifier={QaIdentifier.Search_Filter_Section_Sport}
            refKey={AttributesSearchParam.GreatSportsOffer}
        />
    );
};

export default Sport;
